import React, {useId} from 'react';

// Keep the original chart geometry and series colors, adding light inside each column.
export default function NeonColumn({x, y, width, height, fill, value}) {
  const id = `column-${useId().replace(/:/g, '')}`;
  if (![x,y,width,height].every(Number.isFinite) || width <= 0 || height === 0) return null;
  const top = Math.min(y, y + height), size = Math.abs(height);
  const negative = (Array.isArray(value) ? value[value.length - 1] : value) < 0;
  const edge = negative ? top + size : top;
  const inset = Math.min(1, width / 8), radius = Math.min(2, width / 4, size / 2);
  return <g className="neon-column">
    <defs>
      <linearGradient id={`${id}-glass`} x1="0" y1="0" x2="1" y2="0">
        <stop offset="0%" stopColor="#fff" stopOpacity=".3"/>
        <stop offset="20%" stopColor="#fff" stopOpacity=".04"/>
        <stop offset="65%" stopColor="#fff" stopOpacity=".13"/>
        <stop offset="100%" stopColor="#00132a" stopOpacity=".34"/>
      </linearGradient>
      <pattern id={`${id}-scan`} width="6" height="8" patternUnits="userSpaceOnUse">
        <path d="M0 0H6" stroke="#d6faff" strokeOpacity=".09"/>
      </pattern>
    </defs>
    <rect x={x} y={top} width={width} height={size} rx={radius} fill={fill}/>
    <rect x={x} y={top} width={width} height={size} rx={radius} fill={`url(#${id}-glass)`}/>
    <rect x={x} y={top} width={width} height={size} rx={radius} fill={`url(#${id}-scan)`}/>
    <path d={`M${x+inset} ${top+inset}V${top+size-inset}`} stroke="#d5fcff" strokeOpacity=".38" strokeWidth=".8"/>
    <path className="neon-column-cap" d={`M${x+inset} ${edge}H${x+width-inset}`} stroke="#e1fdff" strokeOpacity=".85" strokeWidth="1.5"/>
  </g>;
}
